import { CreateExternalIntegrationIdProvider } from "@redotech/redo-model/integrations/returns/Integrations";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum NonRmaIntegrationStatusKey {
  AUTHORIZENET = "authorizenet",
  BUBBLEHOUSE = "bubblehouse",
  COMMENT_SOLD = "comment-sold",
  CREDITSYARD = "creditsyard",
  CUSTOM_RETURN = "custom-return",
  GLOBALE = "globale",
  IDF_SHIPPING = "idf-shipping",
  KATANA = "katana",
  KLAVIYO = "klaviyo",
  LOOP = "loop",
  LOOPZ = "loopz",
  LUMINOUS = "luminous",
  PURPLE_DOT = "purple-dot",
  REFUNDID = "refundid",
  RISE_AI = "rise-ai",
  RIVO = "rivo",
  SEKO = "seko",
  TEAMWORK_COMMERCE = "teamwork-commerce",
  TIKTOK_SHOP = "tiktok-shop",
}

export const IntegrationStatusKey = {
  ...NonRmaIntegrationStatusKey,
  ...CreateExternalIntegrationIdProvider,
} as const;
export type IntegrationStatusKey =
  (typeof IntegrationStatusKey)[keyof typeof IntegrationStatusKey];

const integrationStatusSchema = z.object({ isConnected: z.boolean() });

export const getAllIntegrationStatuses = {
  name: "getAllIntegrationStatuses" as const,
  input: z.null(),
  output: z.record(createEnum(IntegrationStatusKey), integrationStatusSchema),
};
